module.exports = __webpack_public_path__ + "assets/icon-netHeight-net108Or112.9951ce24.svg";